export default __webpack_public_path__ + "static/events-light-4ec8efd5094d508ae1ce343a50a0da9f.png";